import { useState } from "react";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import AuthShell from "./AuthShell";
import { api } from "../lib/api";

export default function CheckEmail({ email }) {
  const [busy, setBusy] = useState(false);
  const resend = async () => {
    setBusy(true);
    try { await api.post("/auth/resend-verification", { email }); toast.success("Te enviamos un nuevo enlace ✦"); }
    catch { toast.error("No se pudo reenviar, inténtalo más tarde"); }
    finally { setBusy(false); }
  };
  return (
    <AuthShell testid="check-email" overline="Un paso más" title="Revisa tu correo.">
      <MailCheck className="text-[#C9A25E] mb-5" size={36} />
      <p className="text-zinc-300 leading-relaxed mb-6">
        Te enviamos un enlace a <strong data-testid="check-email-address" className="text-white">{email}</strong>.
        Haz clic en él para confirmar tu cuenta y entrar a tu panel. Si no lo ves, revisa la carpeta de spam.
      </p>
      <button data-testid="check-email-resend" onClick={resend} disabled={busy} className="btn-ghost text-sm">
        {busy ? "Enviando…" : "Reenviar el correo"}
      </button>
    </AuthShell>
  );
}
